import { Grid } from '@chakra-ui/react'
import { useEffect } from 'react'

import { AnniversaryCard } from '@/containers/dashboard/AnniversaryCard'
import { DraftsCard } from '@/containers/dashboard/DraftsCard'
import { OverLimitDiscountRequestCard } from '@/containers/dashboard/OverLimitDiscount/OverLimitDiscountRequestCard'
import { Stats } from '@/containers/dashboard/Stats'
import { useAuth } from '@/context/AuthContext'
import { useApp } from '@/hooks/useApp'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import { Product } from 'BrokerTsLib/src/enums'
import { CustomWaypoint } from '../components/CustomWaypoint'
import { NewsCard } from '../containers/dashboard/NewsCard'
import { useSidebar } from '../context/SidebarContext'
import type { PageSection } from '../layouts/components/Sidebar'


export const Dashboard = () => {
  const { pageSections, setPageSections } = useSidebar()
  const { product } = useApp()
  const { user } = useAuth()
  const { translate } = useTranslationsContext()

  useEffect(() => {
    const array: PageSection[] = []

    if (user?.allowNews) {
      array.push({
        id: 'news',
        title: translate('ui.Dashboard.Section.News', 'Novinky'),
        children: <NewsCard id="news" />
      })
    }

    array.push({
      id: 'stats',
      title: translate('ui.Dashboard.Section.Stats', 'Statistiky'),
      children: <Stats id="stats" />
    })

    if ((user?.allowDiscountsOverLimit ?? false) && (user?.approveDiscountsOverLimit ?? false)) {
      array.push({
        id: 'overLimitDiscounts',
        title: translate('ui.Dashboard.Section.OverLimitDiscounts', 'Žádosti o nadlimitní slevu'),
        children: <OverLimitDiscountRequestCard id="overLimitDiscounts" />
      })
    }

    array.push({
      id: 'drafts',
      title: translate('ui.drafts', 'Rozpracované nabídky'),
      children: <DraftsCard id="drafts" />
    })

    if (product != Product.TravelInsurance) {
      array.push({
        id: 'anniversary',
        title: translate('ui.Dashboard.Section.Anniversary', 'Blížící se výročí smluv'),
        children: <AnniversaryCard id="anniversary" />
      })
    }

    setPageSections(array)
  }, [product, user, setPageSections, translate])

  return (
    <Grid sx={{ gap: { base: 5, md: 8 }, gridTemplateColumns: '1fr' }}>
      {pageSections.map(x => (
        <CustomWaypoint key={x.id} sectionId={x.id}>
          {x.children}
        </CustomWaypoint>
      ))}
    </Grid>
  )
}